import { httpsCallable } from "firebase/functions";
import { functions, auth } from "../firebase";
export async function connectGoogleCalendar(clinicId) {
  const response = await httpsCallable(
    functions,
    "startGoogleCalendarConnection",
  )({ clinicId });
  window.location.assign(response.data.url);
}
export async function disconnectGoogleCalendar(clinicId) {
  return httpsCallable(
    functions,
    "disconnectGoogleCalendarConnection",
  )({ clinicId });
}
export async function importGoogleCalendar(clinicId) {
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(
    "https://us-central1-gestor-de-consultorio.cloudfunctions.net/importGoogleCalendarEvents",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ clinicId }),
    },
  );
  if (!response.ok) throw new Error("No fue posible importar el calendario.");
  return response.json();
}
